let domLoaded = false;
let igReady = false;

function handleExperiment() {
  if (domLoaded && igReady) {
    // Images ATF
    const ImagesATF = window.igData?.user.getTestGroup(
      "c5e07a44-b68f-4a8f-943c-a85003e2d31e"
    );
    if (ImagesATF?.name === "Var A") {
      document.body.classList.add("c-images-atf-test");
      function injectSeeMoreItem() {
        const grid = document.querySelector(".oke-mediaGrid-container");
        if (!grid) return;

        const existing = grid.querySelector(".see-more-injected");
        if (existing) existing.remove();

        const items = grid.querySelectorAll(
          ".oke-mediaGrid-item:not(.see-more-injected)"
        );
        const itemCount = items.length;

        const isMobile = window.innerWidth < 1024; // adjust breakpoint if needed
        if ((isMobile && itemCount === 5) || (!isMobile && itemCount === 8)) {
          const newItem = document.createElement("div");
          newItem.className = "oke-mediaGrid-item see-more-injected";

          const mediaDiv = document.createElement("div");
          mediaDiv.className = "oke-media";
          newItem.appendChild(mediaDiv);

          const button = document.createElement("button");
          button.type = "button";
          button.className = "oke-media-link c-see-more-btn";
          button.textContent = "See More";

          button.addEventListener("click", () => {
            const targetBtns = document.querySelectorAll(
              ".oke-mediaOverlay-button"
            );
            const lastBtn = targetBtns[targetBtns.length - 1];
            if (lastBtn) lastBtn.click();
          });

          mediaDiv.appendChild(button);
          grid.appendChild(newItem);
        }
      }

      setTimeout(() => {
        injectSeeMoreItem();
        const gridContainer = document.querySelector(
          ".oke-mediaGrid-container"
        );
        if (gridContainer) {
          const mutationObserver = new MutationObserver(() =>
            setTimeout(() => {
              injectSeeMoreItem();
            }, 1000)
          );
          mutationObserver.observe(gridContainer, {
            childList: true,
            subtree: true,
          });
        }
      }, 4000);
      let lastWidth = window.innerWidth;
      window.addEventListener("resize", () => {
        const newWidth = window.innerWidth;
        if (lastWidth <= 1429 && newWidth >= 1430) {
          const grid2 = document.querySelector(".oke-mediaGrid-container");
          const existing = grid2.querySelector(".see-more-injected");
          if (existing) {
            existing.remove();
          }
        }
        lastWidth = newWidth;
      });
    }

    //  Test Search bar
    const searchBar = window.igData?.user.getTestGroup(
      "e66636b8-6df0-40d8-8157-9c9e01258cf8"
    );

    if (window.location.pathname === "/" || window.location.pathname === "") {
      if (searchBar?.name === "Var A - canvas") {
        document.body.classList.add("c-search-varA-test");
      } else if (searchBar?.name === "Var B - 5000+") {
        document.body.classList.add("c-search-varB-test");
      } else if (searchBar?.name === "Var C - products") {
        document.body.classList.add("c-search-varC-test");
      } else if (searchBar?.name === "Var D - Beach") {
        document.body.classList.add("c-search-varD-test");
      } else {
        document.body.classList.add("c-search-control-test");
      }
    } else {
      document.body.classList.add("c-search-control-test");
    }

    //  Test Estimates
    const estimateTime = window.igData?.user.getTestGroup(
      "c864541e-a13c-40a1-b61d-caf4d44ec39c"
    );

    if (estimateTime?.name === "Var A - 3-5 days") {
      document.body.classList.add("c-estimates-varA-test");
    } else if (estimateTime?.name === "Var B - Exact Date") {
      const targetDate = addBusinessDays(new Date(), 4);
      const options = { weekday: "long", month: "long", day: "numeric" };
      document.getElementById("c-delivery-date").textContent =
        targetDate.toLocaleDateString("en-US", options);
      document.body.classList.add("c-estimates-varB-test");
    } else if (estimateTime?.name === "Var C - Bar") {
      orderTracker();
      document.body.classList.add("c-estimates-varC-test");
    }
  }
}

function orderTracker() {
  const getBusinessDays = (date, days) => {
    let currentDate = new Date(date),
      added = 0;
    while (added < days) {
      currentDate.setDate(currentDate.getDate() + 1);
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) added++;
    }
    return new Date(currentDate);
  };

  const formatDate = (d) =>
    d.toLocaleDateString("en-US", { day: "numeric", month: "short" });
  const formatRange = (start, end) => {
    const s = formatDate(start),
      e = formatDate(end);
    return s === e ? s : `${s} - ${e}`;
  };

  const today = new Date();
  document.getElementById("c-order-date").textContent = formatDate(
    getBusinessDays(today, 0)
  );
  document.getElementById("c-packed-date").textContent = formatRange(
    getBusinessDays(today, 1),
    getBusinessDays(today, 2)
  );
  document.getElementById("c-delivery-date-var-c").textContent = formatRange(
    getBusinessDays(today, 3),
    getBusinessDays(today, 5)
  );
}

function addBusinessDays(startDate, days) {
  let date = new Date(startDate);
  let addedDays = 0;

  while (addedDays < days) {
    date.setDate(date.getDate() + 1);
    let day = date.getDay();
    if (day !== 0 && day !== 6) {
      addedDays++;
    }
  }
  return date;
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiment();

  if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    document.documentElement.classList.add("safari");
  }

  document
    .querySelector(".c-header__search-new")
    ?.addEventListener("click", function (e) {
      e.preventDefault();
      const detailsEl = document
        .querySelector(".header__icon--search")
        ?.closest("details");
      if (detailsEl) {
        detailsEl.setAttribute("open", "");
        detailsEl.dispatchEvent(new Event("toggle", { bubbles: true }));
      }
    });
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiment();
});
